export default __webpack_public_path__ + "static/bg-a02e57348938649d1f0c98d4116587f6.png";